module.exports = __webpack_public_path__ + "img/mobile/BetBar/btn-sound_on@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/BetBar/btn-sound_on@3x.png
// module id = 607
// module chunks = 0